import { IdNumNomeDTO, ResultPagDTO } from '@/interfaces/base-dto';
import TypePatient, { PacienteAgrupadoParmDTO, PacienteExistFiltrosDTO, PacienteFiltroDTO, PacienteParmDTO } from '@/interfaces/patient';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

export function getPatientsCombo(name:string = null, clientUnitsIds: number[] = [], clientsIds: number[] = [], id: number = null): Observable<any[]> {
  if (clientUnitsIds == null) {
    clientUnitsIds = [];
  }
  if (clientsIds == null){
    clientsIds = [];
  }
  return from(apiClient.get(`${ENDPOINTS.PATIENT}/combo`, {nome: name, idsUnidades: clientUnitsIds, idsClientes: clientsIds, id: id })).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function listPatients(filtros: PacienteFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT_LIST_PAGINATION}`, filtros)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getPatientDetails(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT}/${id}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getPatientAvailableAddressesUnit(idUnit: string): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT}/unidades/${idUnit}/enderecos`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getPatientClientUnitDetails(idUnit: number): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT}/unidades/${idUnit}/dados-basicos`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getPatientCaloricWeight(id: string, idClientUnit:Number, refWeight:Number): Observable<Number> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT}/${id}/pesocalorico`, {pesoReferencia: refWeight, idUnidade: idClientUnit})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function savePatient(payload: PacienteParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PATIENT, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function updatePatient(payload: PacienteParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.PATIENT, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getPatientTypes(idUnidade: number, dataNascimento: string): Observable<any> {
  return from(apiClient.get(ENDPOINTS.PATIENT_TYPE, {idUnidade, dataNascimento})).pipe(
    map((r: any) => (!!r.data ? r.data : '')),
  );
}

export function calculateImc(weight: number, height: number): Observable<TypePatient> {
  return from(apiClient.get(ENDPOINTS.PATIENT_IMC, {peso: weight, altura: height})).pipe(
    map((r: any) => (!!r.data ? r.data : '')),
  );
}

export function saveMergePatient(payload: PacienteAgrupadoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PATIENT_MERGE, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getIdPatientLatest(ids: number[]): Observable<number> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT_LATEST}`, {idsPaciente: ids})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function listPatientsExistClient(filtros: PacienteExistFiltrosDTO): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.PATIENT_EXIST_CLIENTS}`, filtros)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}